import { Modal, ModalBase } from 'src/ui/components/Modal/Modal';
import { Appointment } from 'src/gql/graphql';
import { AppointmentFullInfoCard } from '../../../AppointmentFullInfoCard/AppointmentFullInfoCard';
import { Heading } from '../../../../../../ui/components/Heading/Heading';
import styles from './ViewMoreAppointmentDetailsModal.module.scss';

interface ViewMoreAppointmentDetailsModalI extends ModalBase {
  appointment: Appointment;
}

export const ViewMoreAppointmentDetailsModal = ({
  appointment,
  isOpen,
  setIsOpen,
}: ViewMoreAppointmentDetailsModalI) => {
  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Heading className={styles.heading} headingLevel="h2">
        Cita detallada
      </Heading>
      <AppointmentFullInfoCard appointment={appointment} />
    </Modal>
  );
};
